interface IErrorMessageObj {
  [key: string]: string;
}

// 에러 코드 예시
const errorMessageObj: IErrorMessageObj = {
  GENERAL_NETWORK_ERROR: '네트워크 요청에 실패했습니다.',
};

export const getErrorMessage = (errorCode: string): string => {
  if (!errorCode) {
    return 'Unhandled Error';
  }

  return errorMessageObj[errorCode] ?? errorCode;
};
